import { render, staticRenderFns } from "./ReminderDetail.vue?vue&type=template&id=cbf0b33a"
import script from "./ReminderDetail.vue?vue&type=script&lang=js"
export * from "./ReminderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports